import React from 'react';
import { HistorySectionProps } from './dashboard.types';
import styles from './Dashboard.module.css';

/**
 * History Section Component
 * 
 * Displays user's question history with a table showing recent questions,
 * answers, dates, and fields. Includes pagination.
 */
const HistorySection = ({ }: HistorySectionProps) => {
  // Mock data for history
  const recentQuestions = [
    {
      id: 1,
      text: "What are the contraindications for endodontic treatment?",
      answer: "Contraindications include vertical root fractures, non-restorable teeth, and insufficient periodontal support...",
      date: "Dec 28, 2025",
      field: "Endodontics"
    },
    {
      id: 2,
      text: "Explain the classification of periodontal diseases.",
      answer: "Periodontal diseases are classified into gingivitis, chronic periodontitis, aggressive periodontitis...",
      date: "Dec 26, 2025",
      field: "Periodontology"
    },
    {
      id: 3,
      text: "Protocol for managing avulsed permanent teeth?",
      answer: "Immediate reimplantation is the treatment of choice. If not possible, store in milk or HBSS...",
      date: "Dec 24, 2025",
      field: "Traumatology"
    },
    {
      id: 4,
      text: "Composite resin layering techniques for anterior restorations.",
      answer: "Layering involves using different opacities (dentin, enamel, translucent) to mimic natural tooth structure...",
      date: "Dec 20, 2025",
      field: "Restorative"
    },
    {
      id: 5,
      text: "Differential diagnosis of white lesions in the oral cavity.",
      answer: "Differential diagnosis includes leukoplakia, lichen planus, candidiasis, and frictional keratosis...",
      date: "Dec 18, 2025",
      field: "Oral Pathology"
    }
  ];

  return (
    <section className={styles.historySection}>
      <h3 className={styles.sectionTitle}>History</h3>
      <p className={styles.sectionDescription}>Here is an overview of your past activity</p>

      <div className={styles.tableContainer}>
        <div className={styles.questionsTable}>
          <div className={styles.tableHeader}>
            <span>Question</span>
            <span>Date</span>
            <span>Field</span>
            <span>Action</span>
          </div>

          {recentQuestions.map((item) => (
            <div key={item.id} className={styles.tableRow}>
              <div className={styles.questionCell}>
                <div className={styles.questionIcon}>💬</div>
                <div>
                  <div className={styles.questionText}>{item.text}</div>
                  <div className={styles.questionAnswer}>{item.answer}</div>
                </div>
              </div>
              <div className={styles.dateCell}>{item.date}</div>
              <div className={styles.fieldCell}>{item.field}</div>
              <div className={styles.actionCell}>
                <button className={styles.viewButton}>View</button>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.pagination}>
          Showing 5 recent items
        </div>
      </div>
    </section>
  );
};

export default HistorySection; 